import { DatePipe } from '@angular/common';
import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { AlertComponent } from './alert.component';

/**
 * Perché un'App è in sola lettura (spec 004 FR-009, FR-025, FR-033): cantiere archiviato, diritto
 * venuto meno, App ritirata. Con `since` mostra da quando; con `until` fino a quando resta modificabile.
 */
@Component({
  selector: 'bs-read-only-banner',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [AlertComponent, DatePipe],
  host: { class: 'block' },
  template: `
    <bs-alert [variant]="until() ? 'info' : 'warning'" [heading]="heading()" [testId]="testId()">
      {{ message() }}
      @if (until(); as date) {
        Resta modificabile fino al {{ date | date: 'longDate' }}, poi sarà consultabile in sola
        lettura.
      }
    </bs-alert>
  `,
})
export class ReadOnlyBannerComponent {
  readonly message = input.required<string>();
  readonly heading = input<string>('Sola lettura');
  /** Data di fine del preavviso, per un'App ritirata ancora modificabile. */
  readonly until = input<string | null>(null);
  readonly testId = input<string | null>('read-only-banner');
}
